import React, { useState } from "react";
import { useCallback } from "react";
import { useEffect } from "react";
import styled from "styled-components";
import TriangleDown from "../../SVG/TriangleDown";
import TriangleRight from "../../SVG/TriangleRight";
import SPLogo from "../../Images/sp-logo.png";

const PIXI = window.PIXI;
const Select = styled.select`
  background-color: #181d25;
  color: #fff;
  padding: 4px;
  border: none;
  margin: 4px;
  border-radius: 4px;
`;
const Group = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 2em;
  background-color: #1f252f;
  border-radius: 4px;
  box-shadow: 0px 3px 3px -20px rgba(0, 0, 0, 0.2),
    0px 5px 20px 0px rgba(0, 0, 0, 0.14), 0px 4px 20px 8px rgba(0, 0, 0, 0.12);
  padding: 5px;
`;

const GroupTitle = styled.div`
  cursor: pointer;
`;

const Open = styled.div`
  svg {
    width: 10px;
    float: left;
    margin-left: 10px;
    margin-top: 6px;
  }
`;

const Title = styled.div`
  font-size: 1.1em;
  background-color: #282f3c;
  padding: 0.3em;
  border-radius: 4px;
  text-align: center;
  cursor: pointer;
  border-bottom: 1px solid #161a21;
`;
const Input = styled.input`
  border: 1px solid #232531 !important;
  padding-left: 0.3em !important;
  font-size: 0.9em !important;
  background-color: #12161d !important;
  border-radius: 3px !important;
  cursor: ew-resize;
`;
export default function OPTAWidget({ item }) {
  const [open, setOpen] = useState();
  const [value, setValue] = useState(false);
  const [prefixValue, setPrefixValue] = useState("");
  const options =
    item.type === "TEXT"
      ? [
          { name: "First Name", value: "firstName" },
          { name: "Last Name", value: "lastName" },
          {
            name: "Batting Average",
            value: "battingStats.battingAverage",
          },
          { name: "Home Runs", value: "battingStats.hits.homeRuns" },
          { name: "RBIs", value: "battingStats.runsBattedIn.total" },
          {
            name: "On-Base Percentage",
            value: "battingStats.onBasePercentage",
          },
          {
            name: "Stolen Bases",
            value: "battingStats.stolenBases.total",
          },
          { name: "Hits", value: "battingStats.hits.total" },
          {
            name: "Earned Run Average",
            value: "pitchingStats.earnedRunAverage",
          },
          { name: "Wins", value: "pitchingStats.record.wins" },
          {
            name: "Wins, Losses, Saves",
            value: {
              code: "function({data}) { return data.pitchingStats.record.wins + ','  + data.pitchingStats.record.losses + ', ' + data.pitchingStats.saves.total }",
            },
          },
          {
            name: "Strikeouts",
            value: "pitchingStats.strikeouts.total",
          },
          { name: "Pitch Count", value: "pitchingStats.pitches.total" },
          {
            name: "Innings Pitched",
            value: "pitchingStats.inningsPitched",
          },
        ]
      : [
          {
            name: "Player Image (firstname_lastname.png)",
            value: {
              prefix: "",
              code: "function({data}) {return data.firstName + '_' + data.lastName + '.png'}",
            },
          },
          {
            name: "Team Image (nickname.png)",
            value: {
              prefix: "",
              code: "function({data}) {return data.team.nickname + '.png'}",
            },
          },
        ];
  useEffect(() => {
    setValue(
      options.findIndex(
        (o) =>
          o.name === item.optaWidget?.name ||
          o.value === item.optaWidget?.variable
      )
    );
    setPrefixValue(
      options.find(
        (o) =>
          o.name === item.optaWidget?.name ||
          o.value === item.optaWidget?.variable
      )?.prefix
    );
  }, [item, options]);

  return (
    <Group>
      <GroupTitle onClick={() => setOpen(!open)}>
        <Open>
          {open && <TriangleDown />}
          {!open && <TriangleRight />}
        </Open>
        <Title>
          <img height="20" src={SPLogo} />
        </Title>
      </GroupTitle>

      {open && (
        <>
          <Select
            onChange={(event) => {
              item.optaWidget = {
                name: options[event?.currentTarget.value].name,
                variable: options[event?.currentTarget.value].value,
                code: options[event?.currentTarget.value].code,
              };

              setValue(event?.currentTarget.value);
            }}
            value={value}
          >
            {options.map((item, index) => {
              return <option value={index}>{item.name}</option>;
            })}
          </Select>
          {options?.[value]?.value?.prefix !== undefined && (
            <>
              Placeholder eg. folder/
              <Input
                value={item.optaWidget.prefix}
                onChange={(e) => {
                  item.optaWidget = {
                    ...item.optaWidget,
                    prefix: e.currentTarget.value,
                  };
                  setPrefixValue(e?.currentTarget.value);
                }}
              />
            </>
          )}
        </>
      )}
    </Group>
  );
}
